import { type ITotalsInfo } from '../interfaces';

export const defaultTotals: ITotalsInfo = {
  topStories: 0,
  commentary: 0,
  featuredStories: 0,
  published: 0,
  publishedTopStories: 0,
  publishedCommentary: 0,
  publishedFeaturedStories: 0,
};
